<template>
  <div>
    <input-base
        ref="base"
        :read-only="readOnly"
        :editor-mode="editorMode"
        :validated-field="validatedField"
        :field-config="fieldConfig"
        :grid-editor="gridEditor"
        :open-from-grid="openFromGrid"
    >
 <template v-slot:editor>
        <b-input v-model="validatedField.value" :readonly="readOnly">
        </b-input>
        <div v-if="currentColorHex"
             class="ml-1 mr-1"
             :style="'background-color: ' + currentColorHex + '; border-radius: 10px; height: 35px; width: 35px; display: inline-block'">
        </div>
        <div class="mt-1 ml-2 d-inline-block"
             v-if="!currentColorHex"
             style="width: 30px; height: 35px; border-radius: 5px">
          <font-awesome-icon
              :icon="['fa-duotone', 'fa-square-xmark']"
              style="font-size: 30px; color: #00668B"/>
        </div>
        <b-button
            v-if="!readOnly"
            data-test-path="select-button"
            class="form-button d-none d-xl-inline-block"
            variant="plm-action"
            :disabled="readOnly"
            @click="selectPantone"
        >
          <font-awesome-icon
              icon="a-regular fa-palette"
              class="mr-2"/>
          Select
        </b-button>
        <b-button
            class="form-button-icon d-xl-none"
            variant="plm-action"
            :disabled="readOnly"
            @click="selectPantone"
        >
          <font-awesome-icon icon="fa-regular fa-palette" class="mr-2"/>
        </b-button>
      </template>

      <template slot="label-links">
        <!--    TODO moze kiedys z tym wrocimy, na razie usuwamy - wprowadza zbyt wiele bledow w systemie, dzialanie tych przyciskow jest niepoprawnie obsluzone-->
        <!--      <span v-if="editEnabled && validatedField && validatedField.value" class="pl-0">-->
        <!--        <b-link v-if="editEnabled && validatedField && validatedField.value" @click="edit()" class="px-0 pr-1 pl-1"-->
        <!--                style=" height: 16px;">-->
        <!--            <font-awesome-icon icon="pencil-alt" transform="shrink-4"></font-awesome-icon>-->
        <!--        </b-link>-->
        <!--      </span>-->
      </template>
    </input-base>
  </div>
</template>

<script>
import ReachInput from "@/components/inputs/ReachInput";
import FormValidatedField from "@/components/forms/FormValidatedField";
import TextFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/TextFormFieldConfig";
import FormModel from "@/components/forms/FormModel";
import FooterButton from "@/components/navbar/FooterButton.vue";
import InputBase from "@/components/inputs/InputBase.vue";
import PantoneActivity from "@/components/tools/pantone/PantoneActivity.vue";
import pantone from "@/server/com/silkplm/rpc/Pantone";

export default {
  name: "PantoneRenderer",
  computed: {
    pantone() {
      return pantone
    }
  },
  components: {
    InputBase,
    FooterButton,
    ReachInput},

  mounted() {
    this.onChangeColor();
  },

  props: {
    validatedField: {type: FormValidatedField, required: false},
    fieldConfig: {type: TextFormFieldConfig, required: false},
    mode: {default: null},
    openFromGrid: {default: false},
    gridEditor: {default: null},
    parentForm: {type: FormModel}
  },

  watch: {
    validatedField: function (val) {
      this.onChangeColor();
    },
    "validatedField.value": function (val) {
      this.onChangeColor();
    }
  },

  methods: {
    setReadOnly(readOnly) {
      this.readOnly = this.fieldConfig.readOnly || readOnly;
    },
    async selectPantone() {
      if (this.$parent.$options.name === "GridCellEditor") {
        this.$parent.close();
      }
      let pantoneSelectActivity = await ActivityManager.showActivity(PantoneActivity, {
        selectMode: true,
        initialPantone: this.validatedField.value
      });
      let result = await pantoneSelectActivity.getResult();
      if (result) {
        this.validatedField.value = result.pantone;
      }
      if (this.$parent.$options.name === "GridCellEditor") {
        await this.$parent.saveAndClose();
      }
    },

    async onChangeColor() {
      let queryNumber = ++this.lastQuery;
      let pantoneColor = await Rpc.Pantone.pantoneByName(this.validatedField.value);
      if (queryNumber !== this.lastQuery) {
        return;
      }
      if (pantoneColor) {
        this.currentColorHex = pantoneColor.hex;
      } else {
        this.currentColorHex = null;
      }
    },

    setEditorMode(val) {
      this.editorMode = val;
    }
  },

  data: () => ({
    readOnly: true,
    editorMode: false,
    currentColorHex: '',
    lastQuery: 0,
  })
}
</script>

<style scoped>

</style>